import { useState } from "react";
import { toast } from "sonner";
import { X, Receipt, ImagePlus } from "lucide-react";
import { api, errMsg, formatIDR } from "@/lib/api";

export function PayoutForm({ balance, onDone, onClose }) {
  const [amount, setAmount] = useState(balance.balance);
  const [note, setNote] = useState("Payout mingguan");
  const [proof, setProof] = useState(null);
  const [saving, setSaving] = useState(false);
  const preview = proof && proof.type.startsWith("image/") ? URL.createObjectURL(proof) : null;
  const submit = async (e) => {
    e.preventDefault();
    if (!proof) return toast.error("Lampirkan foto bukti transfer");
    if (proof.size > 5 * 1024 * 1024) return toast.error("Ukuran bukti maksimal 5 MB");
    if (Number(amount) <= 0 || Number(amount) > balance.balance) return toast.error("Nominal harus 1 s.d. saldo talent");
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("talent_id", balance.talent_id); fd.append("amount", String(Number(amount))); fd.append("note", note); fd.append("proof", proof);
      await api.post("/admin/payouts", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`Payout ${formatIDR(Number(amount))} ke ${balance.name} dicatat`);
      onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setSaving(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 flex items-center justify-center p-4" onClick={onClose}>
      <form onSubmit={submit} className="bg-card rounded-xl w-full max-w-md p-6 space-y-4" onClick={(e) => e.stopPropagation()} data-testid="payout-form">
        <div className="flex items-start justify-between gap-3">
          <div><p className="font-heading font-medium text-slate-800 inline-flex items-center gap-2"><Receipt size={16} strokeWidth={1.5} className="text-primary" />Bayar {balance.name}</p><p className="text-xs text-slate-500 mt-1">Saldo tersedia {formatIDR(balance.balance)}{balance.whatsapp_business ? ` · WA resmi +${balance.whatsapp_business}` : ""}</p></div>
          <button type="button" className="p-2 rounded-lg hover:bg-secondary" onClick={onClose} aria-label="Tutup" data-testid="payout-form-close"><X size={18} strokeWidth={1.5} /></button>
        </div>
        <label className="block text-xs text-slate-500">Nominal (Rp)<input type="number" min={1} max={balance.balance} step={500} className="input-soft mt-1" value={amount} onChange={(e) => setAmount(e.target.value)} required data-testid="payout-amount" /></label>
        <label className="block text-xs text-slate-500">Catatan<input className="input-soft mt-1" value={note} onChange={(e) => setNote(e.target.value)} maxLength={120} data-testid="payout-note" /></label>
        <div>
          <p className="text-xs text-slate-500">Bukti transfer <span className="text-rose-600">*</span></p>
          <label className={`mt-1 flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed px-4 py-5 text-sm cursor-pointer transition-colors ${proof ? "border-primary bg-secondary" : "border-border hover:bg-secondary"}`} data-testid="payout-proof-label">
            {preview ? <img src={preview} alt="Bukti transfer" className="max-h-40 rounded-md" data-testid="payout-proof-preview" /> : <ImagePlus size={22} strokeWidth={1.5} className="text-slate-400" />}
            <span className="text-slate-600">{proof ? proof.name : "Pilih foto / PDF bukti transfer (maks. 5 MB)"}</span>
            <input type="file" className="hidden" accept="image/jpeg,image/png,image/webp,application/pdf" onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) setProof(f); }} data-testid="payout-proof-file" />
          </label>
        </div>
        <div className="flex gap-2 justify-end">
          <button type="button" className="btn-ghost h-10" onClick={onClose}>Batal</button>
          <button className="btn-primary h-10 px-5" disabled={saving || !proof} data-testid="payout-submit">{saving ? "Menyimpan..." : "Catat payout"}</button>
        </div>
      </form>
    </div>
  );
}
